import { render, staticRenderFns } from "./ProcsHstScreen2.vue?vue&type=template&id=b85a3daa"
import script from "./ProcsHstScreen2.vue?vue&type=script&lang=js"
export * from "./ProcsHstScreen2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports